interface Props {
  rotulo: string;
  consumido: number;
  alvo: number;
  cor: string;
  unidade?: string;
  /** Quando presente, desenha a faixa de incerteza — ver a nota abaixo. */
  faixa?: { baixo: number; alto: number } | null;
}

/**
 * Anel de progresso de macro.
 *
 * A faixa de incerteza é a razão de este componente não ser um `<progress>`.
 * Quando a refeição veio de foto, o total do dia tem barra de erro grande, e
 * mostrar "1.800 kcal" com uma precisão que não existe é exatamente como os
 * apps de foto mentem. Aqui o arco sólido é o valor estimado e o arco pálido é
 * a faixa plausível.
 */
export function AnelMacro({ rotulo, consumido, alvo, cor, unidade = "g", faixa }: Props) {
  const raio = 34;
  const circunferencia = 2 * Math.PI * raio;
  const fracao = alvo > 0 ? Math.min(consumido / alvo, 1.35) : 0;

  const fracaoAlta = faixa && alvo > 0 ? Math.min(faixa.alto / alvo, 1.35) : null;
  const excedeu = fracao > 1.02;

  return (
    <div className="flex flex-col items-center gap-1">
      <svg viewBox="0 0 80 80" className="h-20 w-20 -rotate-90">
        <circle cx="40" cy="40" r={raio} fill="none" stroke="rgb(var(--c-borda))" strokeWidth="7" />

        {fracaoAlta !== null && fracaoAlta > fracao && (
          <circle
            cx="40" cy="40" r={raio} fill="none"
            stroke={cor} strokeWidth="7" strokeLinecap="round" opacity="0.28"
            strokeDasharray={circunferencia}
            strokeDashoffset={circunferencia * (1 - Math.min(fracaoAlta, 1))}
          />
        )}

        <circle
          cx="40" cy="40" r={raio} fill="none"
          stroke={excedeu ? "rgb(var(--c-alerta))" : cor}
          strokeWidth="7" strokeLinecap="round"
          strokeDasharray={circunferencia}
          strokeDashoffset={circunferencia * (1 - Math.min(fracao, 1))}
          className="transition-[stroke-dashoffset] duration-500"
        />
      </svg>

      <span className="rotulo">{rotulo}</span>
      <span className="text-sm font-semibold tabular-nums">
        {Math.round(consumido)}
        <span className="text-suave">/{Math.round(alvo)}{unidade}</span>
      </span>
    </div>
  );
}
